import React, {useState} from 'react'
import Dialog from '@material-ui/core/Dialog'
import {DatePicker} from '@material-ui/pickers'
import DialogActions from '@material-ui/core/DialogActions'
import {Button} from '@material-ui/core'
import {withNamespaces} from 'react-i18next'

function PickerDialog(props) {
    const t = props.t
    const dialogData = props.dialogData
    const [date, setDate] = useState(dialogData.value.toString())

    return (
        <Dialog open={dialogData.open} onClose={props.onClose}>
            <DatePicker
                autoOk
                variant="static"
                views={dialogData.views}
                maxDate={new Date()}
                value={date}
                onChange={setDate}
            />
            <DialogActions>
                <Button onClick={() => props.onClose()}>
                    {t('cancel')}
                </Button>
                <Button onClick={() => props.onClose(date)} autoFocus>
                    {t('ok')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default withNamespaces()(PickerDialog)
